import React, { useState } from "react";
import Sidebar from "./Finalize/Sidebar";
import ListingTable from "./Finalize/ListingTable";
import FeatherIcon from "feather-icons-react";
import { useFormik } from "formik";
import { createOrder } from "utlis/Apis/SaleOrder_API";
import { setGlobalLoading } from "redux/actions/actionCommon";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { ERROR_WHILE__NAME } from "utlis/AppMessages/AppMessages";
import { UNKNOWN_ERROR_OCCURED } from "utlis/AppMessages/AppMessages";
import { ERROR_WHILE_CREATING_ORDER } from "utlis/AppMessages/AppMessages";
import { ORDER__ADDED_SUCCESSFULLY } from "utlis/AppMessages/AppMessages";
import { clearLocalStorageValue, saveToLocalStorage } from "utlis/helpers/Common/CommonHelperFunctions";
import useStoreUrl from "utlis/CustomHooks/useStoreUrl";

function SaleOrdersFormFinalizeView(props) {
  const { authState, customer, bAddress, sAddress, saveAddresses, currency,
    setBAddress, setSAddress, countries, lines, token_id, setGoSteps, order, getCart, setOrder } = props

  const [coupon_code, setCoupon] = useState("")
  // const [stripe_token, setStripe_token] = useState("123")
  // const [card_number, setCard_number] = useState(123)
  // const [card_expiry_month, setCard_expiry_month] = useState(123)
  // const [card_expiry_year, setCard_expiry_year] = useState(123)
  // const [card_cvv, setCard_cvv] = useState(123)
  // const [shipping_amount, setShipping_amount] = useState(123)
  // const [coupon_discount, setCoupon_discount] = useState("20%")
  // const [sale_order_no, setSaleOrderNo] = useState("20")
  const [manual_discount, setManualDiscount] = useState("0")
  const [terms, setTerms] = useState("")
  const [comments, setComment] = useState("")
  const [staffNotes, setStaffNotes] = useState("")

  // store url
  const [storeUrl] = useStoreUrl()


  const createOrder_ = () => {
    window.scrollTo(0, 0)
    if (order.payment_processor !== "CASH" && !order.stripe_token) {
      toast.dismiss();
      toast.error("Card payment is pending", {
        autoClose: 3000,
      })
    }
    const customer_id = customer.user_id
    delete bAddress.same
    delete sAddress.same
    delete bAddress.city
    delete sAddress.city
    delete bAddress.state
    delete sAddress.state
    delete bAddress.country
    delete sAddress.country

    const values = {
      billing_person: bAddress, shipping_person: sAddress, customer_id, temp_order_id: token_id,
      //stripe_token, card_number, card_expiry_month, card_expiry_year, card_cvv, shipping_amount, coupon_discount,
      coupon_code: order.coupon_code, payment_processor: order.payment_processor
    }
    if (order.payment_processor !== "CASH") {
      values.stripe_token = order.stripe_token
    }

    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    createOrder(headers, values).then(res => {
      setGlobalLoading(false)
      const cartData = res.data
      if (cartData.success) {
        // setCreateButtonLoading(false)
        window.scrollTo(0, 0)
        clearLocalStorageValue("temp_id")
        saveToLocalStorage("temp_customer", JSON.stringify({}))
        saveToLocalStorage("temp_sa", JSON.stringify({}))
        saveToLocalStorage("temp_ba", JSON.stringify({}))

        toast.dismiss();
        props.history.push(storeUrl + '/my-sales/sale-orders', {
          shouldReload: true
        })
        toast.success(ORDER__ADDED_SUCCESSFULLY, {
          autoClose: 2000,
          onClose: () => { }
        })
      }
      if (cartData.error) {
        console.log(ERROR_WHILE_CREATING_ORDER, res)
        // setCreateButtonLoading(false)
        toast.dismiss();
        toast.error(cartData.message || ERROR_WHILE_CREATING_ORDER, {
          autoClose: 3000,
        })
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} createCart `, err.message)
      toast.dismiss();
      toast.error(UNKNOWN_ERROR_OCCURED, {
        autoClose: 2500,
        onClose: () => {
          setGlobalLoading(false)
          // setCreateButtonLoading(false)
        }
      })
    })

  }

  const formik = useFormik({})

  return (
    <React.Fragment>
      {/* app card */}
      <div
        className="app-card mb-3 mb-lg-4 sale-order-wrapper">
        <div
          className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center ${formik?.touched?.active && formik?.errors?.active
            ? "has-msg msg-error"
            : ""
            }`}
        >
        </div>
        <div className="st-form flex-wrap mb-0">
          <div className="app-card-content st-border-light align-items-center sale-order-finalize">
            <div className="sale-order-content">
              <div className="content-left">
                <ListingTable formik={formik}
                  lines={lines}
                  // sale_order_no={sale_order_no}
                  // setSaleOrderNo={setSaleOrderNo}
                  terms={terms}
                  setTerms={setTerms}
                  comments={comments}
                  setComment={setComment}
                  staffNotes={staffNotes}
                  setStaffNotes={setStaffNotes}
                />
              </div>
              <div className="content-right">
                <Sidebar
                  formik={formik}
                  bAddress={bAddress}
                  sAddress={sAddress}
                  customer={customer}
                  countries={countries}
                  coupon_code={coupon_code}
                  setCoupon={setCoupon}
                  manual_discount={manual_discount}
                  setManualDiscount={setManualDiscount}
                  setGoSteps={setGoSteps}
                  lines={lines}
                  order={order}
                  setOrder={setOrder}
                  token_id={token_id}
                  setSAddress={setSAddress}
                  setBAddress={setBAddress}
                  saveAddresses={saveAddresses}
                  getCart={getCart}
                  currency={currency}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="app-card-content bg-white  d-flex align-items-center justify-content-end mt-3">
          <button
            type="button"
            className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2`}
            onClick={() => { props.setGoSteps(2) }}
          >
            <FeatherIcon
              icon="arrow-left"
              size="14"
              className="icon me-1"
            />

            <span>Back</span>
          </button>
          <button
            type="button"
            // className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
            className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center`}
            // disabled={createButtonDisable}
            onClick={() => { createOrder_() }}
          >
            <FeatherIcon
              icon="download"
              size="14"
              className="icon ms-1"
            />
            {/* {
              createButtonLoading ? (
                <Spinner animation="border" size="sm" />
              ) : ( */}
            <span>Save & Process</span>
            {/* )
            } */}

          </button>
        </div>

      </div>
    </React.Fragment>
  );
}


const getDataFromStore = state => {
  return {
    authState: state.auth,
    sideBarVisibility: state.common.sideBarVisibility
  };
}

const dispatchActionsToProps = dispatch => {
  return {
    setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
  }
}

export default connect(getDataFromStore, dispatchActionsToProps)(SaleOrdersFormFinalizeView)